import * as React from 'react';
import { connect } from 'react-redux';

import PlayFillInBlankQuestion from '../../../Shared/components/fillInBlank/playFillInBlankQuestion';
import { TURK } from '../../../Shared/utils/constants';
import { getGradedResponsesWithCallback, saveResponseToCMS } from '../../actions/responses.js';

export interface PlayFillInTheBlankQuestionProps {
  dispatch: any;
  isLastQuestion?: boolean;
  language?: string;
  nextQuestion: () => void;
  question: any;
  setResponse: (response: any) => void;
  submitResponse: (response: any) => void;
}

export class PlayFillInTheBlankQuestion extends React.Component<PlayFillInTheBlankQuestionProps> {

  getGradedResponsesWithCallback = (questionKey: string, callback: (data: any) => void) => {
    return getGradedResponsesWithCallback(questionKey, callback);
  }

  updateResponseResource = (response: any, key: string, attempts: any, dispatch: any) => {
    const latestAttempt = attempts[attempts.length - 1];
    const isFirstAttempt = !latestAttempt;
    dispatch(saveResponseToCMS(response.response, isFirstAttempt));
  }

  render() {
    const { dispatch, isLastQuestion = false, language, nextQuestion, question, setResponse, submitResponse } = this.props;

    return (
      <PlayFillInBlankQuestion
        dispatch={dispatch}
        getGradedResponsesWithCallback={this.getGradedResponsesWithCallback}
        isLastQuestion={isLastQuestion}
        language={language}
        mode={TURK}
        nextQuestion={nextQuestion}
        previewMode={false}
        question={question}
        setResponse={setResponse}
        submitResponse={submitResponse}
        updateResponseResource={this.updateResponseResource}
      />
    );
  }
}

function select(props) {
  return {
  };
}

export default connect(select)(PlayFillInTheBlankQuestion);
